import { Award, BookOpen, Bug, CalendarPlus, ClipboardCheck, CreditCard, FileText, Home, MessageCircle, ShoppingBag, type LucideIcon } from 'lucide-react';

// Navigation de l'espace élève (refonte du 14/10/2026) : mêmes écrans qu'avant, libellés courts pour la barre du bas.

export type Tab =
  | 'dashboard'
  | 'reserver'
  | 'commander'
  | 'paiements'
  | 'documents'
  | 'livret'
  | 'messages'
  | 'evaluation'
  | 'permis'
  | 'support';

export interface NavItem {
  id: Tab;
  label: string;
  icon: LucideIcon;
}

/** Ordre d'affichage (barre du haut sur ordinateur, menu « Plus » sur téléphone). */
export const NAV: NavItem[] = [
  { id: 'dashboard', label: 'Accueil', icon: Home },
  { id: 'reserver', label: 'Réserver', icon: CalendarPlus },
  { id: 'messages', label: 'Messages', icon: MessageCircle },
  { id: 'paiements', label: 'Paiements', icon: CreditCard },
  { id: 'commander', label: 'Commander', icon: ShoppingBag },
  { id: 'documents', label: 'Documents', icon: FileText },
  { id: 'livret', label: 'Livret', icon: BookOpen },
  { id: 'evaluation', label: 'Évaluation', icon: ClipboardCheck },
  { id: 'permis', label: 'Mon permis', icon: Award },
  // Dernière entrée de « Plus » (téléphone) et du menu du compte (ordinateur) ; jamais dans les onglets du haut.
  { id: 'support', label: 'Signaler un problème', icon: Bug },
];

export const TAB_IDS = NAV.map((n) => n.id);

/** Barre du bas (téléphone, tablette) : quatre entrées, le reste dans « Plus ». */
export function bottomTabs(items: NavItem[]): { main: NavItem[]; more: NavItem[] } {
  const wanted: Tab[] = ['dashboard', 'reserver', 'messages', items.some((i) => i.id === 'paiements') ? 'paiements' : 'livret'];
  const main = wanted.map((id) => items.find((i) => i.id === id)).filter((i): i is NavItem => !!i);
  return { main, more: items.filter((i) => !wanted.includes(i.id)) };
}

/** Pastille de non-lus (« 99+ » au-delà), avec le nombre lu par les lecteurs d'écran. */
export function unreadLabel(count: number) {
  return ` ${count} non lu${count > 1 ? 's' : ''}`;
}
